import { Typography, Card, CardContent, Box, Grid } from "@mui/material";
import { DadoValorPrinter } from "../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { useFormContext } from "react-hook-form";
import { IDataNotaFiscalEntrada } from "../../../../../../types/api/fiscal/pesquisar-nota-fiscal-entrada";
import { formatarValorMonetario } from "../../../../../../helpers/masks";


export default function CardPrincipal() {

    //formulario
    const { getValues } = useFormContext()
    const notaFiscal: IDataNotaFiscalEntrada = getValues("notaFiscal")

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" component="h2" gutterBottom>
                    Nota fiscal
                </Typography>

                <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 4}}>
                        <DadoValorPrinter
                            titulo="Espécie/Número/Série"
                            valor={`NF${notaFiscal.numero_nota}/${notaFiscal.serie_nota}`}
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 4}}>
                        <DadoValorPrinter
                            titulo="Emitente"
                            valor={`${notaFiscal.nome_emissor ?? 'N/A'}`}
                        />
                        <Typography>{`CNPJ: ${notaFiscal.cnpj_emissor ?? 'N/A'} / Endereço: ${notaFiscal.endereco_emissor?.uf ?? 'N/A'} - ${notaFiscal.endereco_emissor?.municipio ?? 'N/A'} `}</Typography>
                    </Grid>
                    <Grid size={{xs: 12, md: 4}}>
                        <Box sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                            <Typography variant="body2" color="text.secondary">
                                Total
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                {formatarValorMonetario(notaFiscal.valor_total)}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid size={{xs: 12, md: 4}}>
                        <DadoValorPrinter
                            titulo="Natureza da operação"
                            valor={notaFiscal.natureza_operacao || '-'}
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 4}}>
                        <DadoValorPrinter
                            titulo="Destinatário"
                            valor={`${notaFiscal.nome_destinatario ?? '-'}`}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
